import { jsx as _jsx } from "react/jsx-runtime";
import { BaseEdge, getSmoothStepPath } from '@xyflow/react';
import { L_FLOW_HEX } from '../../../constants';
/**
 * Component renders "logical" type of connection of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_EDGE_TYPES.
 */
const RFLogicalEdgeFC = ({ sourceX, sourceY, targetX, targetY, 
//selected,
markerEnd, sourcePosition, targetPosition, style = {} }) => {
    const [edgePath] = getSmoothStepPath({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        borderRadius: 0
    });
    return (_jsx(BaseEdge, { path: edgePath, markerEnd: markerEnd, style: { ...style, stroke: L_FLOW_HEX, strokeWidth: 1 } }));
};
export const RFLogicalEdge = RFLogicalEdgeFC;
//# sourceMappingURL=RFLogicalEdge.js.map